module.exports = __webpack_public_path__ + "img/004-oman.f8832d1e.svg";